import React, { useEffect, useState, useRef } from 'react'
import { Badge, ListItem } from '@material-ui/core'
import moment from 'moment'
import './Message.css'

function ActiveSellers({ sellers = [], onClick, onFirstSellerLoaded, isArchive, activeSeller }) {
    const [firstSellerEl, setFirstSellerEl] = useState(null)
    const hasClickedFirst = useRef(false)
    const assignFirstSeller = (element, index) => {
        if (element && index === 0) setFirstSellerEl(element)
    }

    useEffect(() => {
        if (firstSellerEl && sellers.length > 0 && !hasClickedFirst.current) {
            hasClickedFirst.current = true
            firstSellerEl.click()
            onFirstSellerLoaded?.(sellers[0].userid)
        }
    }, [firstSellerEl, isArchive, sellers])

    return (
        <ul className="activeSellers">
            {sellers.map((seller, index) => {
                const isActive = activeSeller.index === index
                return (
                    <ListItem
                        button
                        key={seller.userid || index}
                        autoFocus={index === 0}
                        onClick={(e) => onClick(e, index, seller.userid)}
                        ref={(el) => assignFirstSeller(el, index)}
                        className={`seller_${seller.userid} ${isActive ? 'active' : ''}`}
                    >
                        <span className="material-icons userAvatar">account_circle</span>
                        <div className="d-flex justify-content-between flex-wrap w-100">
                            <div className="asContent d-flex justify-content-between w-100">
                                <h4 className="asTitle">{seller.username}</h4>
                                <h6>{moment(seller.date_sent).format('DD-MM-YYYY')}</h6>
                            </div>
                            <div className="asContent d-flex justify-content-between w-100">
                                <h5 className="asSubject">
                                    {seller.message
                                        ? seller.message.split('<')[0]
                                        : 'Attachment Sent'}
                                </h5>
                                {seller.unreadcount > 0 && !isArchive && (
                                    <Badge badgeContent={seller.unreadcount}></Badge>
                                )}
                            </div>
                        </div>
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default ActiveSellers
